import React, { PropTypes } from 'react';

class ListItem extends React.Component {

    constructor(props, context) {
        super(props, context);
        
        this.state = {
            index: this.props.index,
            name: this.props.name
        };
    }

    // LIFECYCLE METHODS

    componentWillReceiveProps = (nextProps) => {
        this.setState({
            index: nextProps.index,
            name: nextProps.name
        });
    }

    // EVENT HANDLERS

    handleMouseDown = (mouseEvent) => {
        if (mouseEvent.button === 0) {
            this.props.mouseDown(this.state.index);
        }
    }

    handleMouseOver = () => { this.props.mouseOver(this.state.index); }

    // RENDER METHOD

    render = () => {
        return (
            <li
                style={{paddingTop: "3px", paddingBottom: "3px"}}
                className={this.props.classNames}
                onMouseDown={this.handleMouseDown}
                onMouseOver={this.handleMouseOver}
                title={this.state.name.length > 50 ? this.state.name : null}
                id={this.props.id} key={this.props.id}>
                    {this.state.name}
            </li>
        );
    }
}

ListItem.propTypes = {
    classNames: PropTypes.string,
    id: PropTypes.number,
    index: PropTypes.number,
    mouseDown: PropTypes.func,
    mouseOver: PropTypes.func,
    name: PropTypes.string
};

export default ListItem;



/** WEBPACK FOOTER **
 ** ./src/app/components/ListItem.js
 **/